export const DEFAULT_OPTIONS = {
    maintainAspectRatio: false,
    legend: {
        display: false
    },
    tooltips: {
        backgroundColor: "#f5f5f5",
        titleFontColor: "#333",
        bodyFontColor: "#666",
        bodySpacing: 4,
        xPadding: 12,
        mode: "nearest",
        intersect: 0,
        position: "nearest"
    },
    responsive: true,
    scales: {
        yAxes: [
            {
                gridLines: {
                    drawBorder: false,
                    color: "rgba(225,78,202,0.1)",
                    zeroLineColor: "transparent"
                },
                ticks: {
                    suggestedMin: 60,
                    suggestedMax: 120,
                    padding: 20,
                    fontColor: "#9e9e9e"
                }
            }
        ],
        xAxes: [
            {
                gridLines: {
                    drawBorder: false,
                    color: "rgba(225,78,202,0.1)",
                    zeroLineColor: "transparent"
                },
                ticks: {
                    padding: 20,
                    fontColor: "#9e9e9e"
                }
            }
        ]
    }
};
const DEFAULT_GRADIENT = () => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 10, 1000, 20);
    gradient.addColorStop(0, "#7fc0fb");
    gradient.addColorStop(1, "#006fd3");
    return gradient;
};

export const DEFAULT_DATASET_OPTIONS = {
    fill: true,
    backgroundColor: DEFAULT_GRADIENT,
    hoverBackgroundColor: "rgba(1, 111, 213, 0.7)",
    borderColor: "rgba(1, 111, 213, 1)",
    borderWidth: 2,
    borderDash: [],
    borderDashOffset: 0.0
};

export default class HistogramAssembler {

    toChartJs(dataJson) {
        const {title, data: unformattedData, label} = dataJson;
        const data = this._formatData(unformattedData, label);
        return {data, options: DEFAULT_OPTIONS, title};
    }

    _formatData(unformattedData, label) {
        let labels = [];
        let dataPoint = [];
        unformattedData.forEach(dat => {
            labels = [...labels, ...Object.keys(dat)];
            dataPoint = [...dataPoint, ...Object.values(dat)];
        });
        return {
            labels: labels,
            datasets: [
                {
                    label: label,
                    ...DEFAULT_DATASET_OPTIONS,
                    data: dataPoint
                }
            ]
        };
    };
}